import { expand } from 'uri-template-lite';
import { apiClient } from '../../../common/ApiClient';
import { createApiQueryHook } from '../../../common/queryClient/createApiQueryHook';
import { WaitingStatusesDto } from '../schema/types';
import { UserCalendarUrl } from '../../UserDashboardUrl';

const getWaitingStatuses = () =>
  apiClient
    .get<WaitingStatusesDto[]>(expand(UserCalendarUrl.WAITING_STATUSES))
    .then((response) => response.data);

export const useGetWaitingStatusesQuery = createApiQueryHook(
  ['waiting-statuses'],
  getWaitingStatuses,
);
